/**
 * Home page orchestrator. It wires up the footer's panels.
 */
import * as about from './about.js';

/**
 *
 */
function main(): void {
  about.init();
}

main();
